var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 40",
    style: {
      enableBackground: "new 0 0 42 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#715FF5;}\n\t.st1{fill:#FF6666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24.06,21.99 24.07,22.01 28.83,17.24 28.14,16.55 24.06,20.62 22.77,19.34 22.08,20.04 24.05,22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11.5,10.5 11.5,29.5 30.5,29.5 30.5,23.45 20.14,23.45 20.14,15.68 30.5,15.68 30.5,10.5  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.99,126.36l-9.59-0.02l0.02-10.17l9.59,0.02L26.99,126.36z M18.27,125.47l7.85,0.02l0.02-8.43l-7.85-0.02 L18.27,125.47z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "24.6,114.04 15.01,114.01 14.99,124.16 14.99,124.19 15.86,123.26 15.88,114.89 23.73,114.91  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,170.35c-3.31,0-6-2.69-6-6s2.69-6,6-6s6,2.69,6,6S24.31,170.35,21,170.35z M21,159.16 c-2.86,0-5.19,2.33-5.19,5.19s2.33,5.19,5.19,5.19s5.19-2.33,5.19-5.19S23.86,159.16,21,159.16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.66,166.47l-2.29-1.06v-4.94c0-0.28-0.23-0.51-0.51-0.51s-0.51,0.23-0.51,0.51v5.26c0,0,0,0.01,0,0.01 c0,0.01,0,0.02,0,0.03c0,0.01,0,0.01,0,0.02c0,0.01,0,0.02,0,0.03c0,0.01,0,0.02,0.01,0.03c0,0.01,0,0.01,0.01,0.02 c0,0.01,0.01,0.02,0.01,0.03c0,0.01,0,0.01,0.01,0.02c0,0.01,0.01,0.02,0.01,0.03c0,0.01,0.01,0.01,0.01,0.02 c0,0.01,0.01,0.02,0.01,0.02c0,0.01,0.01,0.01,0.01,0.02c0,0.01,0.01,0.01,0.01,0.02c0.01,0.01,0.01,0.01,0.02,0.02 c0,0.01,0.01,0.01,0.01,0.02c0.01,0.01,0.01,0.01,0.02,0.02c0,0,0.01,0.01,0.01,0.01c0.01,0.01,0.01,0.01,0.02,0.02 c0.01,0,0.01,0.01,0.02,0.01c0.01,0.01,0.01,0.01,0.02,0.02c0.01,0.01,0.01,0.01,0.02,0.01c0.01,0,0.01,0.01,0.02,0.01 c0.01,0.01,0.02,0.01,0.03,0.02c0,0,0.01,0,0.01,0.01l2.58,1.2c0.07,0.03,0.14,0.05,0.21,0.05c0.19,0,0.37-0.11,0.46-0.29 C24.02,166.89,23.91,166.59,23.66,166.47z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.27,208.65c-1.04,0-1.89-0.85-1.89-1.89s0.85-1.89,1.89-1.89h1.07l-1.17-1.65 c-1.91,0.05-3.45,1.62-3.45,3.54c0,1.96,1.59,3.55,3.55,3.55h4.95l-1.18-1.66H17.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.28,206.75c0-1.96-1.59-3.55-3.55-3.55h-4.95l1.18,1.66h3.77c1.04,0,1.89,0.85,1.89,1.89 s-0.85,1.89-1.89,1.89h-1.07l1.17,1.65C26.74,210.24,28.28,208.68,28.28,206.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.37,213.35c-0.15,0-0.29-0.07-0.39-0.2l-8.73-12.24c-0.15-0.21-0.1-0.51,0.11-0.66 c0.21-0.15,0.51-0.1,0.66,0.11l8.73,12.24c0.15,0.21,0.1,0.51-0.11,0.66C25.56,213.32,25.46,213.35,25.37,213.35z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnectIcon);
export default __webpack_public_path__ + "static/media/walletConnectIcon.ef12012716f70b1272cf9fd087d52c37.svg";
export { ForwardRef as ReactComponent };